import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

/** Match Excel export numFmt: yyyy-mm-dd hh:mm */
export function formatExportCell(val) {
  if (val == null || val === "") return "";
  if (val instanceof Date) {
    if (!Number.isFinite(val.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${val.getFullYear()}-${pad(val.getMonth() + 1)}-${pad(
      val.getDate()
    )} ${pad(val.getHours())}:${pad(val.getMinutes())}`;
  }
  return String(val);
}

/**
 * Build A4 landscape PDF table from an Excel export blob.
 */
export async function exportReportPdfFromExcelBlob(
  excelBlob,
  filename,
  fallbackHeaders = []
) {
  const data = await excelBlob.arrayBuffer();
  const workbook = XLSX.read(data, { type: "array", cellDates: true });
  const sheetName = workbook.SheetNames[0];
  if (!sheetName) {
    throw new Error("Export file has no worksheet");
  }
  const worksheet = workbook.Sheets[sheetName];
  const rows = XLSX.utils.sheet_to_json(worksheet, {
    header: 1,
    defval: "",
    raw: false,
  });

  const headerRow = Array.isArray(rows[0]) ? rows[0] : [];
  const headers =
    headerRow.length > 0
      ? headerRow.map((cell) => String(cell ?? ""))
      : fallbackHeaders;

  const body = rows.slice(1).map((row) => {
    const cells = Array.isArray(row) ? row : [];
    return headers.map((_, colIndex) =>
      formatExportCell(cells[colIndex] ?? "")
    );
  });

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4",
  });

  autoTable(doc, {
    head: [headers],
    body,
    styles: {
      fontSize: 6,
      cellPadding: 2,
      overflow: "linebreak",
      lineWidth: 0.25,
      lineColor: [180, 180, 180],
    },
    headStyles: {
      fillColor: [245, 245, 245],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      fontSize: 6.5,
    },
    showHead: "everyPage",
    margin: { top: 28, left: 18, right: 18, bottom: 28 },
    rowPageBreak: "avoid",
  });

  doc.save(filename);
}
